import React from "react";

import PropTypes from "prop-types";
import MainCategoriesStyle from "../../assets/stylesheets/MainCategories.module.css";

import Logger from "../../utils/logger";

const log = Logger.create("CategoryCard");

// import "../../assets/stylesheets/FarmCard.module.css";

export default function EventCard({ event, onClick }) {
  return (
    <div className={MainCategoriesStyle["category-card"]} onClick={onClick}>
      <div className={MainCategoriesStyle["event-card-image-container"]}>
        <img
          src={event.imageUrl}
          alt={event.name}
          className={MainCategoriesStyle["event-card-image"]}
        />
      </div>
      {/* {event.badge && <p className="event-card-badge">{event.badge}hee</p>} */}
      <h3 className={MainCategoriesStyle["event-card-title"]}>{event.title}</h3>
      {/* <p className={MainCategoriesStyle["event-card-location"]}>
        {event.location}
      </p> */}
    </div>
  );
}
